import { MultiselectCommand } from '../../core/model/command';

export const propertyCommand = {
  deleteDocument: 'deleteDocument',
  downloadDocument: 'downloadDocument',
  export: 'export',
  changeVisibility: 'changeVisibility',
  moveToCompany: 'moveToCompany',
  propertyTaxRental: 'propertyTaxRental',
};

export class PropertyMultiselectCommand extends MultiselectCommand {
  constructor(id: string, items: any[], itemsSource: any[], contextId?: string) {
    super(id, items, itemsSource, contextId);
  }
}
